











































































import { Vue, Component, Lifecycle } from "av-ts";
import { ISnackbarNotification } from "./interfaces/models";
import { getBus, NEW_QUEUE_ITEM } from "./util";
import UserService from "./services/UserService";

@Component
export default class GlobalNotification extends Vue {
    pEventQueue: ISnackbarNotification[] = [];
    pNotification: ISnackbarNotification | undefined = undefined;
    snackbarCloseTimeout: number | undefined = undefined;

    snackbarIsClosed = true;

    get notification() {
        return this.pNotification || {};
    }

    get snackbarClass() {
        return {
            "closed": this.snackbarIsClosed
        };
    }
    updateQueue(newItem: ISnackbarNotification) {
        // If the queue was quiet before, trigger first cycle
        if (this.pEventQueue.length === 0) {
            this.$nextTick(() => this.cycleQueue());
        }

        this.pEventQueue.push(newItem);
    }

    closeSnackbar() {
        this.snackbarIsClosed = true;

        if (this.snackbarCloseTimeout !== undefined) {
            window.clearTimeout(this.snackbarCloseTimeout);
        }

        // Wait for the snackbar to close before opening it again
        setTimeout(() => {
            this.shiftQueue();
            this.cycleQueue();
        }, 250);
    }

    showSnackbar() {
        this.snackbarIsClosed = false;
        this.snackbarCloseTimeout = window.setTimeout(() => this.closeSnackbar(), 5000);
    }

    shiftQueue() {
        this.pEventQueue.shift();
    }

    cycleQueue() {
        if (this.pEventQueue.length > 0) {
            const notification = this.pEventQueue[0];
            this.pNotification = notification;
            this.showSnackbar();
        } else {
            this.snackbarIsClosed = true;
        }
    }

    @Lifecycle
    created() {
        getBus().$on(NEW_QUEUE_ITEM, this.updateQueue);
    }

    @Lifecycle
    destroyed() {
        getBus().$off(NEW_QUEUE_ITEM, this.updateQueue);
    }

    read() {
        if (this.pNotification!.id && this.pNotification!.read==false) {
            UserService.markNotificationAsRead(this.pNotification!.id!);
            this.pNotification!.read = true;
        }
    }

    redir(link: string) {
        this.$router.push(link);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/GlobalNotification.vue